import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

const StoreRoleSelect = ({ title, defaultValue = null, handler }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectRole") : title;
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const { storeId, setStoreId } = useContext(StoreContext);

  const handleChange = (e) => {
    setSelectedRole(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getRole = async () => {
    try {
      const response = await apiService.get(`api/v1/store-roles`);
      const availableRoles = response.map((el) => {
        return {
          value: el.id,
          label: el.name,
        };
      });
      setRoles(availableRoles);
      setNewValue(null);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedRole = roles.find((el) => el.value === defaultValue);
    if (selectedRole) setSelectedRole(selectedRole);
  };

  useEffect(() => {
    if (!storeId) return;
    getRole();
  }, [storeId]);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="storeRoleSelect"
          onChange={handleChange}
          value={selectedRole}
          options={roles}
          noOptionsMessage={() => t("messages.noRolesAvailable")}
          placeholder={title}
        />
      </Form.Group>
    </>
  );
};

export default StoreRoleSelect;
